var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('offset-card',{attrs:{"title":"测试页面"}},[_c('demo-sort')],1)}
var staticRenderFns = []

export { render, staticRenderFns }